var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
// Mappings between icon's variants, and design tokens
var regularIconVariantMap = {
    info: {
        color: tokens.colors.blueDark,
        backgroundColor: tokens.colors.white,
    },
    success: {
        color: tokens.colors.green,
        backgroundColor: tokens.colors.navy,
    },
    warning: {
        color: tokens.colors.orangeLight,
        backgroundColor: tokens.colors.navy,
    },
    error: {
        color: tokens.colors.red,
        backgroundColor: tokens.colors.white,
    },
    upgrade: {
        color: tokens.colors.purple,
        backgroundColor: 'transparent',
    },
};
var invertedIconVariantMap = __assign(__assign({}, regularIconVariantMap), { upgrade: __assign(__assign({}, regularIconVariantMap.upgrade), { color: tokens.colors.purpleLight }) });
export function wrapperStyle(_a) {
    var isCentered = _a.isCentered;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: ", ";\n    width: ", ";\n    height: ", ";\n    flex-shrink: 0;\n\n    ", "\n  "], ["\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: ", ";\n    width: ", ";\n    height: ", ";\n    flex-shrink: 0;\n\n    ", "\n  "])), tokens.zIndex.default, tokens.sizing.small, tokens.sizing.small, isCentered && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-left: auto;\n    "], ["\n      margin-left: auto;\n    "]))));
}
export function iconStyle(_a) {
    var variant = _a.variant, inverted = _a.inverted;
    var variantMap = inverted ? invertedIconVariantMap : regularIconVariantMap;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    color: ", ";\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    color: ", ";\n  "])), variantMap[variant].color);
}
export function backgroundStyle(_a) {
    var variant = _a.variant, inverted = _a.inverted;
    var variantMap = inverted ? invertedIconVariantMap : regularIconVariantMap;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    // Creative way to get triangle shape for warning\n    ", "\n  "], ["\n    // Creative way to get triangle shape for warning\n    ", "\n  "])), variant === 'warning'
        ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          width: 0;\n          height: 0;\n          border-left: 6px solid transparent;\n          border-right: 6px solid transparent;\n          border-bottom: 12px solid ", ";\n        "], ["\n          width: 0;\n          height: 0;\n          border-left: 6px solid transparent;\n          border-right: 6px solid transparent;\n          border-bottom: 12px solid ", ";\n        "])), variantMap[variant].backgroundColor) : css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          width: 12px;\n          height: 12px;\n          border-radius: ", ";\n          background-color: ", ";\n        "], ["\n          width: 12px;\n          height: 12px;\n          border-radius: ", ";\n          background-color: ", ";\n        "])), tokens.borderRadius.circle, variantMap[variant].backgroundColor));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
